"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOmniaVideoContent = void 0;
function mockOmniaVideoContent(overrides = {}) {
    return {
        id: 1,
        url: 'http://example.com',
        ...overrides,
    };
}
exports.mockOmniaVideoContent = mockOmniaVideoContent;
